import React from 'react';
import { Placeholder, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';

type DynamicPlaceholderProps = {
  rendering: ComponentRendering;
};

const PartialDesignDynamicPlaceholder = (props: DynamicPlaceholderProps): React.JSX.Element => (
  <Placeholder name={props.rendering?.params?.sig || ''} rendering={props.rendering} disableSuspense={true} />
);

export default PartialDesignDynamicPlaceholder;
